import React, { useEffect, useState } from "react"
import { Formik, Form } from "formik";
import Select from "react-select"
import styled from "styled-components"

const Champ = styled.div`
margin:10px auto;
padding: 0;
`

const AssociationSelect = styled(Select)`
margin: 10px;
max-width: 500px;
display: block;
`

const construitOption = (typeElement, element) => {
  console.log("construction option")
  console.log(element)
  const retour = {}
  switch (typeElement) {
    case 'phototheatre':
      retour.value = element.id
      retour.label = element.nom_fichier
      break
    default:
      break
  }
  console.log(retour)
  return retour
}


const valeurs = (typeElement, elem) => {
  return (elem.map(element => construitOption(typeElement, element)))
}


/**
 * Association d'un theatre avec des phototheatres
 * typeElement theatre
 * typeElementAAssocier phototheatre
 * liste toutes les phototheatres
**/
const ElementFormAssociation = (params) => {

  const {initialValues
    , typeElementAAssocier
    , liste
    , onSubmit} = params

  console.log(`Liste des ${typeElementAAssocier} dans ElementFormAssociation`)
  console.log(liste)

  const [selectedOptions, setSelectedOptions] = useState([]);


  useEffect(() => {
    const alias = `${typeElementAAssocier}s`
    setSelectedOptions(valeurs(typeElementAAssocier, initialValues[alias]))
 }, [initialValues, typeElementAAssocier])

  const handleSelect = (data) => {
    setSelectedOptions(data);
  }

//creation de l'element select multiple
const FormSelect = ({ name, options }) => {

  return (
      <AssociationSelect
        name={name}
        defaultValue={selectedOptions}
        onChange={handleSelect}
        options={options}
        isSearchable={true}
        isMulti
      />
  );
};


  const FormulaireJSX = () => {
      return(
        <Form>
        <Champ>
          <FormSelect
            name={typeElementAAssocier}
            options={liste.map(element => construitOption(typeElementAAssocier, element))}
          />
          <button type="submit" onSubmit={onSubmit}>Associer</button>
        </Champ>
      </Form>)
  }
  return (
        <Formik
          initialValues={selectedOptions}
          onSubmit={onSubmit}
          enableReinitialize={true}>
          <FormulaireJSX />
        </Formik>
  )
}
export default ElementFormAssociation
